import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthToken } from '../../features/auth/useAuthToken';
import { brandConfig } from '../../config/brands';
import './OrganizationCreatedPage.css';

export default function InvitationAcceptedPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setToken } = useAuthToken();
  const organizationName = searchParams.get('organization_name') || '組織';
  const token = searchParams.get('token');

  useEffect(() => {
    // 新しいトークンを適用
    if (token) {
      setToken(token);
    }
  }, [token, setToken]);

  const handleStartUsing = () => {
    // トークンが適用されるまで少し待機してから遷移
    setTimeout(() => {
      navigate('/', { replace: true });
    }, 300);
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <img src="/check_2_green.svg" alt="完了" className="success-check-icon" />
            <h1 className="auth-title">組織への参加が完了しました</h1>
            <p className="auth-subtitle">
              {organizationName} に参加しました
            </p>
          </div>

          <div className="auth-content">
            <div className="success-message">
              <p>
                招待を受諾し、組織への参加が完了しました。
                <br />
                これで{brandConfig.serviceName}のすべての機能をご利用いただけます。
              </p>
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="btn btn-primary btn-large"
                onClick={handleStartUsing}
              >
                利用を開始する
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
